import { useNavigate } from 'react-router-dom'

export const ASSEMBLY_URL = '/assembly/'

export const useGoToAssembly = () => {
  const navigate = useNavigate()

  return {
    go: () => {
      navigate(ASSEMBLY_URL)
    }
  }
}
